import { object, string, number, array } from 'yup'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { topic } from 'components/Wizards/schemas/shared/topic'
import { language } from 'components/Wizards/schemas/shared/language'
import { includeEmojis } from 'components/Wizards/schemas/shared/includeEmojis'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { meta } from '../schemaCommon'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { project } from 'components/Wizards/schemas/shared/project'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'

export const FlowJSchema = ({ generationType }: { generationType: GenerationType }) => {
  const BrainstormDetailsSchema = object({
    content_type: string()
      .oneOf([
        'A Full Content Plan',
        'Social Media',
        'Video',
        'Marketplace Visuals',
        'Ads',
        'Emails',
        'Product Descriptions',
        'Websites',
        'Recruiting Assets',
        'Sales Assets',
        'Customer Service Assets',
      ])
      .default('Social Media')
      .meta({
        label: '',
        placeholder: 'E.g. Social media posts, blog articles, email campaigns',

        oneOfPills: true,
      })
      .transform(safify),
    brand_kit_id: brandKitId
      .meta({
        label: 'Pick a Brand Kit',
      })
      .optional(),
    tone: tone.meta({
      autoFill: false,
    }),
  }).meta({
    title: 'What type of content are you working on?',
    submitLabel: 'Continue',
  }) as StepSchema

  const RefinementSchema = object({
    topic: topic.meta({
      type: 'textarea',
      autoFill: true,
      generate: false,
      generationType,
    }),
    ideas_count: number().default(10).oneOf([5, 10, 15, 20]).meta({
      label: 'How many ideas?',
    }),
  }).meta({
    title: 'What would you like your ideas to be about?',
    submitLabel: 'Continue',
  }) as StepSchema

  const KeywordsSchema = object({
    seo_words: array().of(string()).min(1, 'Please add at least one keyword').default([]).meta({
      label: 'Keywords',
      autoFill: true,
      placeholder: 'Add keywords (press return to separate)',
    }),
    filename,
    project,
    language: language.meta({ overflow: true, autoFill: true }),
    include_emojis: includeEmojis.meta({ overflow: true, autoFill: true }),
  }).meta({
    title: 'Add final details',
    submitLabel: 'Generate Ideas',
  }) as StepSchema

  return {
    meta,
    steps: [BrainstormDetailsSchema, RefinementSchema, KeywordsSchema],
  } as MultiStepSchema<GenerationType>
}
